import React from "react";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";
import AdminSupportsPage from "../../components/AdminSupports/AdminSupoortsPage"


const AdminSupportPage = () => {
  return (
    <div>
      <UserPage />      
      <AdminSupportsPage />
      <Footer />
    </div>
  );
};

export default AdminSupportPage;
